import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { KeyRound, CheckCircle2 } from "lucide-react";
import { api, formatApiError } from "../lib/api";
import { Input } from "./ContactForm";

export default function ChangePassword() {
  const navigate = useNavigate();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (next !== confirm) { setError("La confirmación no coincide."); return; }
    if (next.length < 8) { setError("La nueva contraseña debe tener al menos 8 caracteres."); return; }
    setSubmitting(true);
    try {
      const { data } = await api.post("/auth/change-password", { current_password: current, new_password: next });
      if (data.access_token) localStorage.setItem("token", data.access_token);
      setDone(true);
    } catch (e) {
      setError(formatApiError(e.response?.data?.detail));
    } finally {
      setSubmitting(false);
    }
  };

  if (done) {
    return (
      <div className="max-w-md mx-auto text-center py-10 space-y-4" data-testid="changepw-success">
        <CheckCircle2 className="w-14 h-14 text-[#047857] mx-auto" />
        <h1 className="font-heading text-2xl font-bold">Contraseña actualizada</h1>
        <p className="text-[#475569]">Tu nueva contraseña ya está activa.</p>
        <button onClick={() => navigate(-1)} className="h-12 px-6 rounded-xl bg-[#1E3A8A] text-white font-semibold">Volver</button>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto space-y-6">
      <h1 className="font-heading text-2xl font-bold flex items-center gap-2"><KeyRound className="w-6 h-6 text-[#1E3A8A]" /> Cambiar contraseña</h1>
      <form onSubmit={submit} className="space-y-4">
        <Input label="Contraseña actual" testid="changepw-current" type="password" value={current} onChange={setCurrent} required />
        <Input label="Nueva contraseña (mín. 8 caracteres)" testid="changepw-new" type="password" value={next} onChange={setNext} required />
        <Input label="Confirmar nueva contraseña" testid="changepw-confirm" type="password" value={confirm} onChange={setConfirm} required />
        {error && <p className="text-sm text-[#DC2626]" data-testid="changepw-error">{error}</p>}
        <button type="submit" disabled={submitting} data-testid="changepw-submit-btn"
          className="w-full h-14 rounded-xl bg-[#1E3A8A] text-white font-semibold hover:bg-[#1E40AF] disabled:opacity-50">
          {submitting ? "Actualizando…" : "Actualizar contraseña"}
        </button>
      </form>
    </div>
  );
}
